export const GET_OPERATOR_TOUR_DETAILS_START="GET_OPERATOR_TOUR_DETAILS_START"
export const GET_OPERATOR_TOUR_DETAILS_SUCCESS="GET_OPERATOR_TOUR_DETAILS_SUCCESS"
export const GET_OPERATOR_TOUR_DETAILS_ERROR="GET_OPERATOR_TOUR_DETAILS_ERROR"